module.exports = __webpack_public_path__ + "img/所得税后.aa9632f7.svg";